// extracted by mini-css-extract-plugin
export default {"report_table":"style_report_table__Ch5vJ","card_box_first_tr":"style_card_box_first_tr__j4Hng"};